import {z} from 'zod';

/**
 * Schema for PDF to image conversion response validation
 */
export const storagePdfConvertResponseSchema = z.object({
  accepted: z.array(z.string()),
  rejected: z.array(z.string()),
});

export type StoragePdfConvertResponse = z.infer<typeof storagePdfConvertResponseSchema>;
